import { ChevronDownIcon } from 'lucide-react'
import React, { forwardRef } from 'react'

import { type IconProp } from 'slab/types'
import { mergeRefs } from 'utils/ref_utils'

import { InputBlockField } from './Field'
import { type ColumnSpan } from './types'

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  children: React.ReactNode;
  error?: React.ReactNode;
  label: React.ReactNode;
  leadingIcon?: IconProp;
  placeholder?: string;
  span?: ColumnSpan;
}

export const InputBlockSelect = forwardRef<HTMLSelectElement, SelectProps>(
  ({ children, placeholder, ...props }, forwardedRef) => {
    return (
      <InputBlockField {...props}>
        {({ ref, ...fieldProps }) => (
          <>
            <select
              {...fieldProps}
              ref={mergeRefs(ref, forwardedRef)}
            >
              {!!placeholder && (
                <option disabled={props.required} value=''>
                  {placeholder}
                </option>
              )}
              {children}
            </select>
            <span className='absolute right-2 top-5 pointer-events-none text-gray-500 peer-[:open]:rotate-180 peer-disabled:text-black/25 transition'>
              <ChevronDownIcon aria-hidden size={16} />
            </span>
          </>
        )}
      </InputBlockField>
    )
  }
)
